import { Loader } from '@shared/ui/loader/loader';
import { AnimatePresence, motion } from 'framer-motion';
import { MatchedTeachersSlider } from './matched-teachers-slider';
import { SearchAllTeachersOffer } from './search-all-teachers-offer';
import { matchingBodyVariants } from '../lib/teacher-matching-progress';
import s from '../teacher-matching-progress.module.scss';

export const MatchedTeachersResult = ({ teachers, teachersIsFetched, searchParams }) => (
	<motion.div
		key="matched"
		className={s.matchedBody}
		variants={matchingBodyVariants}
		initial="initial"
		animate="animate"
		exit="exit"
	>
		<AnimatePresence mode="wait" initial={false}>
			{teachersIsFetched ? (
				teachers?.length > 0 ? (
					<MatchedTeachersSlider teachers={teachers}/>
				) : (
					<motion.div
						key="empty"
						className={s.matchedEmpty}
						variants={matchingBodyVariants}
						initial="initial"
						animate="animate"
						exit="exit"
					>
						Мы не нашли подходящих преподавателей
					</motion.div>
				)
			) : (
				<motion.div
					key="loader"
					className={s.matchedLoader}
					variants={matchingBodyVariants}
					initial="initial"
					animate="animate"
					exit="exit"
				>
					<Loader/>
				</motion.div>
			)}
		</AnimatePresence>
		{teachersIsFetched && <SearchAllTeachersOffer searchParams={searchParams} />}
	</motion.div>
);
